/**
 * Reset único por valor: ao publicar uma versão que exige limpar IndexedDB e forçar novo login,
 * defina aqui a mesma string de versão do `package.json` (após `setVersion` no build, se aplicável).
 *
 * - Deixe `''` para desligar (nenhum reset automático).
 * - Usuários em build **anterior** a esta versão não resetam até atualizarem o app.
 * - Depois do reset, gravamos o valor aplicado; para um novo reset em outro release, altere
 *   esta string de novo (ex.: de `'1.3.80'` para `'1.4.0'`).
 *
 * O carrinho (`cart_details`, `cart_id`, etc. em localStorage) é preservado — ver `maybeApplyForcedCacheReset`.
 */
export const FORCE_CACHE_RESET_AT_VERSION = '1.4.73';
